import type { SetStorageQuotaInput, StorageOveragePolicy, StorageQuota } from "@lumora/bridge";
import { useState } from "react";
import { formatBytesGB } from "./siteTrafficMetrics.js";

export type StorageQuotaFormProps = {
  quota: StorageQuota;
  onSave: (input: SetStorageQuotaInput) => void | Promise<void>;
};

/** Decimal GB text -> save payload in bytes. Blank/invalid/negative => 0 (plan default). */
export function buildStorageQuotaInput(
  gbText: string,
  overagePolicy: StorageOveragePolicy,
): SetStorageQuotaInput {
  const gb = Number.parseFloat(gbText);
  const quotaBytes = Number.isFinite(gb) && gb > 0 ? Math.round(gb * 1e9) : 0;
  return { quotaBytes, overagePolicy };
}

/** Platform-admin storage quota editor. Dumb view: state via props + local form state. */
export function StorageQuotaForm({ quota, onSave }: StorageQuotaFormProps) {
  const [gb, setGb] = useState(quota.quotaBytes > 0 ? String(quota.quotaBytes / 1e9) : "0");
  const [policy, setPolicy] = useState<StorageOveragePolicy>(quota.overagePolicy);

  return (
    <form
      className="platform-storage-form"
      data-platform-storage-form
      onSubmit={(e) => {
        e.preventDefault();
        void onSave(buildStorageQuotaInput(gb, policy));
      }}
    >
      <label>
        Quota (GB)
        <input type="number" min="0" step="any" value={gb} onChange={(e) => setGb(e.target.value)} />
      </label>
      <p className="muted platform-storage-hint">
        0 = plan default. Effective quota: {formatBytesGB(quota.effectiveQuotaBytes)}
      </p>
      <label>
        Overage policy
        <select
          value={policy}
          onChange={(e) => setPolicy(e.target.value as StorageOveragePolicy)}
        >
          <option value="block">block</option>
          <option value="meter">meter</option>
        </select>
      </label>
      <button type="submit">Save</button>
    </form>
  );
}
